export default __webpack_public_path__ + "static/logo-0ecd1704af89e7d354cf2e8e0a340281.png";